// extracted by mini-css-extract-plugin
module.exports = {"root":"RSStepHeader_root__098tD"};